import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { useTranslation } from "react-i18next";
import { Chip } from "primereact/chip";
import NadaConsta from "../../../../components/nadaConsta";
import { formatValueReais, formatPhoneNumber } from '../../../../utils/ValidationUtils';
import { DataTable } from 'primereact/datatable';
import React from 'react';
import { Column } from 'primereact/column';
import { formatarParaMoedaBRL } from '../../../../utils';
import { Card } from 'primereact/card';
import Divider from '../../../../components/menu/Divider';
 
export function ProtestoNacional({
  data,
}: any) {
 
  const { t } = useTranslation();
  
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {data.dados?.total_protestos && data.dados?.total_protestos > 0 ? (<span style={{ color: '#C70039', fontSize: '1.5rem' }} className="pi pi-exclamation-triangle"><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>{t('protestos')}</span></span>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>{t('protestos')}</span>)} </div>;
  }
  
  return (
    <Panel headerTemplate={headerTemplate}>
      {(!data.dados?.total_protestos || data.dados?.total_protestos === 0) ? (<NadaConsta />) : 
      (
        <>
          {data.dados.protestos_por_estados.map((prot:any) => (
            <div>
              <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('uf')}</label>
                      <Chip style={{width:"100%"}} label={prot.estado} />
                  </div>
                </div>
                <div className="col">
                <div >
                      <label className="label-dados">{t('quantidade')}</label>
                      <Chip style={{width:"100%"}} label={prot.total_protestos} />
                  </div>
                </div>
              </div>
              {prot.protestos_por_cartorio.map((cart:any) => (
                <Panel header={'Cartórios ' + prot.estado}>
                  <div className="grid">
                    <div className="col p-fluid flex flex-wrap">
                      <div >
                          <label className="label-dados">{t('cartorio')}</label>
                          <Chip style={{width:"100%"}} label={cart.cartorio} />
                      </div>
                    </div>
                    <div className="col">
                    <div >
                          <label className="label-dados">{t('cidade')}</label>
                          <Chip style={{width:"100%"}} label={cart.cidade} />
                      </div>
                    </div>
                  </div>
                  <div className="grid">
                    <div className="col p-fluid flex flex-wrap">
                      <div >
                          <label className="label-dados">{t('telefone')}</label>
                          <Chip style={{width:"100%"}} label={cart.telefone} />
                      </div>
                    </div>
                    <div className="col">
                    <div >
                          <label className="label-dados">{t('endereco')}</label>
                          <Chip style={{width:"100%"}} label={cart.endereco} />
                      </div>
                    </div>
                  </div>
                  {cart.protestos && (
                    <div>
                      <br></br>
               
                      <DataTable size="small" value={cart.protestos} tableStyle={{ minWidth: '50rem' }}>
                        <Column field="data_protesto" header={t('data')}></Column>
                        <Column field="valor_protesto" header={t('valor')}></Column>
                      </DataTable>
                    </div>
                  )}
                </Panel>
              ))}
              
              
            </div>
          ))}
        </>
      )}
      <>
        
        <br></br>
        
      </>
      
      
    </Panel>
  )
}